/* ============================================================
   SMASHA — Tunnel Configurator JS
   - Open/close tunnel
   - Step navigation (next/prev/keyboard)
   - Progress bar
   - Color/size selection → variant matching
   - Live SVG preview update
   - Pack 2+1 multi-config + AJAX multi-add
   - Recap auto-update
============================================================ */
(function () {
  'use strict';

  const SELECTORS = {
    tunnel: '[data-sm-tunnel]',
    openBtn: '[data-sm-open-tunnel]',
    closeBtn: '[data-sm-close]',
    backBtn: '[data-sm-back]',
    nextBtn: '[data-sm-next]',
    submitBtn: '[data-sm-submit]',
    form: '[data-sm-form]',
    track: '[data-sm-track]',
    panels: '[data-sm-step]',
  };

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.from((root || document).querySelectorAll(sel)); }

  function fmtMoney(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  // ============================================================
  // INIT each tunnel section
  // ============================================================
  document.addEventListener('DOMContentLoaded', initAllTunnels);
  if (document.readyState !== 'loading') initAllTunnels();

  function initAllTunnels() {
    $$(SELECTORS.tunnel).forEach(initTunnel);
  }

  function initTunnel(tunnel) {
    if (tunnel.__smInit) return;
    tunnel.__smInit = true;

    const form = $(SELECTORS.form, tunnel);
    const track = $(SELECTORS.track, tunnel);
    const panels = $$(SELECTORS.panels, tunnel);
    const totalSteps = panels.length || 4;
    let variants = [];
    try {
      const variantsScript = $('[data-sm-variants]', tunnel);
      if (variantsScript && variantsScript.textContent.trim()) {
        variants = JSON.parse(variantsScript.textContent);
      }
    } catch (e) {
      console.warn('[SM] variants parse fail', e);
    }

    // State
    let currentStep = 0;
    const selected = [];
    const packState = { 2: { active: false }, 3: { active: false } };
    let logoFile = null;

    const stepNames = ['BASE', 'IDENTITÉ', 'PACK 2+1', 'RÉCAP'];

    // ============================================================
    // OPEN / CLOSE — wire from ANYWHERE in document (CTA may be outside tunnel)
    // ============================================================
    $$(SELECTORS.openBtn).forEach(btn => {
      if (btn.__smWired) return;
      btn.__smWired = true;
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        console.log('[SM] Open tunnel clicked');
        openTunnel();
      });
    });
    $$(SELECTORS.closeBtn, tunnel).forEach(btn => {
      btn.addEventListener('click', closeTunnel);
    });

    function openTunnel() {
      console.log('[SM] openTunnel called');
      tunnel.classList.add('sm-open');
      tunnel.setAttribute('aria-hidden', 'false');
      document.body.classList.add('sm-tunnel-open');
      try { updateAll(); } catch (e) { console.warn('[SM] updateAll fail', e); }
      setTimeout(() => {
        const first = $('[data-sm-color], [data-sm-size]', panels[0]);
        if (first) first.focus({ preventScroll: true });
      }, 300);
    }
    function closeTunnel() {
      tunnel.classList.remove('sm-open');
      tunnel.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('sm-tunnel-open');
    }

    // ESC closes
    document.addEventListener('keydown', (e) => {
      if (!tunnel.classList.contains('sm-open')) return;
      if (e.key === 'Escape') closeTunnel();
      if (e.key === 'ArrowRight' && !isInputFocused()) goNext();
      if (e.key === 'ArrowLeft' && !isInputFocused()) goPrev();
    });
    function isInputFocused() {
      const t = document.activeElement;
      return t && (t.tagName === 'INPUT' || t.tagName === 'TEXTAREA' || t.tagName === 'SELECT');
    }

    // ============================================================
    // NAVIGATION
    // ============================================================
    $$(SELECTORS.nextBtn, tunnel).forEach(btn => btn.addEventListener('click', goNext));
    $$(SELECTORS.backBtn, tunnel).forEach(btn => btn.addEventListener('click', goPrev));

    function goNext() {
      if (currentStep < totalSteps - 1) {
        currentStep++;
        updateAll();
      }
    }
    function goPrev() {
      if (currentStep > 0) {
        currentStep--;
        updateAll();
      }
    }

    function updateAll() {
      // Move track
      track.style.transform = `translateX(-${(100 / totalSteps) * currentStep}%)`;

      // Progress bar
      const pct = ((currentStep + 1) / totalSteps) * 100;
      const fill = $('[data-sm-progress-fill]', tunnel);
      if (fill) fill.style.width = pct + '%';

      // Step number / name
      const stepNum = $('[data-sm-step-num]', tunnel);
      const stepName = $('[data-sm-step-name]', tunnel);
      const footerStep = $('.sm-footer-step', tunnel);
      const footerName = $('[data-sm-footer-name]', tunnel);
      if (stepNum) stepNum.textContent = currentStep + 1;
      if (stepName) stepName.textContent = stepNames[currentStep];
      if (footerStep) footerStep.textContent = `ÉTAPE ${currentStep + 1} / ${totalSteps}`;
      if (footerName) footerName.textContent = stepNames[currentStep];

      // Back button
      const backBtn = $(SELECTORS.backBtn, tunnel);
      if (backBtn) backBtn.disabled = currentStep === 0;

      // Hide ENTIRE footer at step 4 (CTA is inside step 4 content)
      const footer = $('[data-sm-tunnel-footer]', tunnel);
      const nextBtn = $(SELECTORS.nextBtn, tunnel);
      if (currentStep === totalSteps - 1) {
        if (footer) footer.hidden = true;
        if (nextBtn) nextBtn.hidden = true;
      } else {
        if (footer) footer.hidden = false;
        if (nextBtn) nextBtn.hidden = false;
      }

      // Scroll active panel to top
      panels.forEach(p => p.scrollTop = 0);

      // Refresh recap if step 4
      if (currentStep === totalSteps - 1) refreshRecap();

      // Refresh footer price
      refreshFooterPrice();
    }

    // ============================================================
    // COLOR + SIZE SELECTION
    // ============================================================
    $$('[data-sm-color]', tunnel).forEach(btn => {
      btn.addEventListener('click', () => {
        $$('[data-sm-color]', tunnel).forEach(b => b.classList.remove('sm-active'));
        btn.classList.add('sm-active');
        const value = btn.dataset.smValue;
        const hex = btn.dataset.smHex;
        const optIdx = parseInt(btn.dataset.smOptionIndex, 10);
        selected[optIdx] = value;
        const nameEl = $('[data-sm-color-name]', tunnel);
        if (nameEl) nameEl.textContent = value;
        updateJerseyColor(hex);
        updateVariant();
      });
    });

    $$('[data-sm-size]', tunnel).forEach(btn => {
      btn.addEventListener('click', () => {
        if (btn.disabled) return;
        $$('[data-sm-size]', tunnel).forEach(b => b.classList.remove('sm-active'));
        btn.classList.add('sm-active');
        const value = btn.dataset.smValue;
        const optIdx = parseInt(btn.dataset.smOptionIndex, 10);
        selected[optIdx] = value;
        const nameEl = $('[data-sm-size-name]', tunnel);
        if (nameEl) nameEl.textContent = value;
        updateVariant();
      });
    });

    // Initialize selected from active buttons
    $$('[data-sm-color].sm-active', tunnel).forEach(b => {
      const idx = parseInt(b.dataset.smOptionIndex, 10);
      selected[idx] = b.dataset.smValue;
    });
    $$('[data-sm-size].sm-active', tunnel).forEach(b => {
      const idx = parseInt(b.dataset.smOptionIndex, 10);
      selected[idx] = b.dataset.smValue;
    });

    function findMatchingVariant() {
      return variants.find(v => v.options.every((opt, i) => {
        if (selected[i] === undefined) return true;
        return opt === selected[i];
      })) || variants[0];
    }

    function updateVariant() {
      const variant = findMatchingVariant();
      if (!variant) return;
      const hiddenInput = $('[data-sm-variant-id]', tunnel);
      if (hiddenInput) hiddenInput.value = variant.id;
      refreshFooterPrice();
      refreshPackPrices();
    }

    function refreshFooterPrice() {
      const variant = findMatchingVariant();
      if (!variant) return;
      const priceEl = $('[data-sm-footer-price]', tunnel);
      if (!priceEl) return;

      let total = variant.price;
      // Slot 2 ajoute son propre prix produit
      if (packState[2].active && packState[2].productPrice) {
        total += packState[2].productPrice;
      }
      // Slot 3 ajoute son prix MAIS sera défalqué en remise (gratuit)
      let discount = 0;
      if (packState[3].active && packState[3].productPrice) {
        total += packState[3].productPrice;
        discount = packState[3].productPrice;
      }
      total -= discount;

      priceEl.textContent = fmtMoney(total);
    }

    function refreshPackPrices() {
      const variant = findMatchingVariant();
      if (!variant) return;
      const p1 = $('[data-sm-slot-price="1"]', tunnel);
      if (p1) p1.textContent = fmtMoney(variant.price);
    }

    // ============================================================
    // LIVE PREVIEW SVG UPDATE
    // ============================================================
    function updateJerseyColor(hex) {
      if (!hex) return;
      $$('[data-sm-jersey-body]', tunnel).forEach(p => {
        // gradient stops
        const svg = p.closest('svg');
        if (!svg) return;
        const mainStop = $('[data-sm-stop="main"]', svg);
        const shadowStop = $('[data-sm-stop="shadow"]', svg);
        if (mainStop) mainStop.setAttribute('stop-color', hex);
        if (shadowStop) shadowStop.setAttribute('stop-color', darken(hex, 0.5));
      });
    }
    function darken(hex, factor) {
      try {
        const c = hex.replace('#', '');
        const r = parseInt(c.substr(0, 2), 16);
        const g = parseInt(c.substr(2, 2), 16);
        const b = parseInt(c.substr(4, 2), 16);
        return '#' + [r, g, b].map(x => Math.max(0, Math.floor(x * factor)).toString(16).padStart(2, '0')).join('');
      } catch (e) { return hex; }
    }

    // Pseudo & number inputs → SVG live
    const pseudoInput = $('[data-sm-input="pseudo"]', tunnel);
    const numberInput = $('[data-sm-input="number"]', tunnel);
    const textInput = $('[data-sm-input="text"]', tunnel);
    const logoInput = $('[data-sm-input="logo"]', tunnel);

    if (pseudoInput) {
      pseudoInput.addEventListener('input', () => {
        $$('[data-sm-jersey-pseudo]', tunnel).forEach(t => {
          t.textContent = pseudoInput.value.toUpperCase() || ' ';
        });
        const counter = $('[data-sm-count="pseudo"]', tunnel);
        if (counter) counter.textContent = `${pseudoInput.value.length}/12`;
      });
    }

    if (numberInput) {
      numberInput.addEventListener('input', () => {
        // strip non-numeric
        numberInput.value = numberInput.value.replace(/\D/g, '');
        $$('[data-sm-jersey-number]', tunnel).forEach(t => {
          t.textContent = numberInput.value || ' ';
        });
        const counter = $('[data-sm-count="number"]', tunnel);
        if (counter) counter.textContent = `${numberInput.value.length}/2`;
      });
    }

    if (logoInput) {
      logoInput.addEventListener('change', (e) => {
        const file = e.target.files[0];
        if (!file) return;
        logoFile = file;
        const fileNameEl = $('[data-sm-filename]', tunnel);
        if (fileNameEl) fileNameEl.textContent = '✓ ' + file.name;

        // Preview logo on SVG
        if (file.type.startsWith('image/')) {
          const reader = new FileReader();
          reader.onload = (ev) => {
            $$('[data-sm-jersey-logo-upload]', tunnel).forEach(img => {
              img.setAttribute('href', ev.target.result);
              img.setAttribute('opacity', '1');
            });
            // Hide text logo to avoid overlap
            $$('[data-sm-jersey-logo]', tunnel).forEach(t => t.setAttribute('opacity', '0'));
          };
          reader.readAsDataURL(file);
        }
      });
    }

    // ============================================================
    // PACK 2+1 SLOTS v2 — Galerie produits
    // ============================================================
    // packState now tracks: { active, productId, productHandle, productTitle, productPrice, productImage, productVariants, selectedVariantId }
    packState[2] = { active: false, productId: null, productHandle: null, productTitle: null, productPrice: 0, productImage: null, productVariants: null, selectedVariantId: null };
    packState[3] = { active: false, productId: null, productHandle: null, productTitle: null, productPrice: 0, productImage: null, productVariants: null, selectedVariantId: null };

    // Toggle slot collapsed/expanded
    $$('[data-sm-slot-toggle]', tunnel).forEach(toggle => {
      const slotNum = toggle.dataset.smSlotToggle;
      toggle.addEventListener('click', (e) => {
        // Don't toggle if click was inside the body
        if (e.target.closest('[data-sm-slot-body]') || e.target.closest('[data-sm-slot-form]')) return;
        const slot = $(`[data-sm-slot="${slotNum}"]`, tunnel);
        const slotForm = $(`[data-sm-slot-form="${slotNum}"]`, tunnel);
        if (!slot || !slotForm) return;

        const isOpen = !slotForm.hidden;
        if (isOpen) {
          slotForm.hidden = true;
          slot.classList.remove('sm-slot-opened');
          packState[slotNum].active = false;
          // Reset product selection
          resetSlotSelection(slotNum);
        } else {
          slotForm.hidden = false;
          slot.classList.add('sm-slot-opened');
          // Note: not active yet — only when product is selected
        }
        refreshFooterPrice();
      });
    });

    // Product card click
    $$('[data-sm-product-select]', tunnel).forEach(card => {
      card.addEventListener('click', (e) => {
        e.stopPropagation();
        const slotNum = card.dataset.smProductSelect;

        // Deselect all cards in this slot
        $$(`[data-sm-product-select="${slotNum}"]`, tunnel).forEach(c => c.classList.remove('sm-selected'));
        card.classList.add('sm-selected');

        // Read product data
        const productId = card.dataset.smProductId;
        const productHandle = card.dataset.smProductHandle;
        const productTitle = card.dataset.smProductTitle;
        const productPrice = parseInt(card.dataset.smProductPrice, 10);
        const productImage = card.dataset.smProductImage;
        let productVariants = [];
        try {
          productVariants = JSON.parse(card.dataset.smProductVariants);
        } catch (e) { console.warn('[SM] variant parse fail', e); }

        // Store in state
        packState[slotNum] = {
          active: true,
          productId,
          productHandle,
          productTitle,
          productPrice,
          productImage,
          productVariants,
          selectedVariantId: productVariants[0]?.id || null,
        };

        // Update config block
        const configBlock = $(`[data-sm-slot-config="${slotNum}"]`, tunnel);
        const nameEl = $(`[data-sm-slot-selected-name="${slotNum}"]`, tunnel);
        const priceEl = $(`[data-sm-slot-selected-price="${slotNum}"]`, tunnel);
        const thumbEl = $(`[data-sm-slot-thumb="${slotNum}"]`, tunnel);
        if (nameEl) nameEl.textContent = productTitle;
        if (priceEl) priceEl.textContent = fmtMoney(productPrice);
        if (thumbEl) thumbEl.style.backgroundImage = `url("${productImage}")`;

        // Populate size select with this product's variants
        const sizeSelect = $(`[data-sm-slot-size="${slotNum}"]`, tunnel);
        if (sizeSelect) {
          sizeSelect.innerHTML = '<option value="">Taille ↓</option>';
          // Get unique sizes from variants (assuming size is one of the options)
          const seen = new Set();
          productVariants.forEach(v => {
            // Try to find the size option (look in options array for XS-XXL pattern)
            let size = null;
            for (const opt of v.options) {
              const up = String(opt).toUpperCase().trim();
              if (['XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL'].includes(up)) {
                size = opt;
                break;
              }
            }
            // Fallback: use first option
            if (!size && v.options[0]) size = v.options[0];
            if (size && !seen.has(size)) {
              seen.add(size);
              const opt = document.createElement('option');
              opt.value = size;
              opt.dataset.variantId = v.id;
              opt.textContent = size + (v.available ? '' : ' (épuisé)');
              if (!v.available) opt.disabled = true;
              sizeSelect.appendChild(opt);
            }
          });

          // On size change, update selectedVariantId
          sizeSelect.addEventListener('change', () => {
            const selectedOpt = sizeSelect.options[sizeSelect.selectedIndex];
            packState[slotNum].selectedVariantId = selectedOpt?.dataset.variantId || null;
          });
        }

        // Show config block
        if (configBlock) {
          configBlock.hidden = false;
          configBlock.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }

        refreshFooterPrice();
      });
    });

    // Reset / Change / Remove slot
    $$('[data-sm-slot-reset]', tunnel).forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        const slotNum = btn.dataset.smSlotReset;
        resetSlotSelection(slotNum);
        refreshFooterPrice();
      });
    });

    function resetSlotSelection(slotNum) {
      // Deselect all cards
      $$(`[data-sm-product-select="${slotNum}"]`, tunnel).forEach(c => c.classList.remove('sm-selected'));
      // Hide config block
      const configBlock = $(`[data-sm-slot-config="${slotNum}"]`, tunnel);
      if (configBlock) configBlock.hidden = true;
      // Clear inputs
      $$(`[data-sm-slot-pseudo="${slotNum}"], [data-sm-slot-number="${slotNum}"]`, tunnel).forEach(i => i.value = '');
      const sizeSelect = $(`[data-sm-slot-size="${slotNum}"]`, tunnel);
      if (sizeSelect) sizeSelect.innerHTML = '<option value="">Taille ↓</option>';
      // Reset state
      packState[slotNum] = { active: false, productId: null, productHandle: null, productTitle: null, productPrice: 0, productImage: null, productVariants: null, selectedVariantId: null };
    }

    // ============================================================
    // RECAP (step 4)
    // ============================================================
    function refreshRecap() {
      const variant = findMatchingVariant();
      if (!variant) return;

      // Color
      const colorBtn = $('[data-sm-color].sm-active', tunnel);
      const colorName = colorBtn ? colorBtn.dataset.smValue : '—';
      const r = (k) => $(`[data-sm-recap="${k}"]`, tunnel);
      if (r('color')) r('color').textContent = colorName;

      // Size
      const sizeBtn = $('[data-sm-size].sm-active', tunnel);
      const sizeName = sizeBtn ? sizeBtn.dataset.smValue : '—';
      if (r('size')) r('size').textContent = sizeName;

      // Pseudo
      const pseudo = pseudoInput ? pseudoInput.value.trim() : '';
      if (r('pseudo')) {
        r('pseudo').textContent = pseudo ? pseudo.toUpperCase() : 'Aucun';
        r('pseudo').style.color = pseudo ? '' : 'var(--sm-mute)';
      }

      // Number
      const num = numberInput ? numberInput.value.trim() : '';
      if (r('number')) {
        r('number').textContent = num || 'Aucun';
        r('number').style.color = num ? '' : 'var(--sm-mute)';
      }

      // Logo
      if (r('logo')) {
        r('logo').textContent = logoFile ? '✓ ' + logoFile.name : 'Aucun';
        r('logo').style.color = logoFile ? '' : 'var(--sm-mute)';
      }

      // Free text
      const txt = textInput ? textInput.value.trim() : '';
      if (r('text')) {
        r('text').textContent = txt || 'Aucun';
        r('text').style.color = txt ? '' : 'var(--sm-mute)';
      }

      // Pack
      const extraRow = $('[data-sm-recap-extra]', tunnel);
      const packLabel = r('pack');
      let count = 1;
      if (packState[2].active) count++;
      if (packState[3].active) count++;
      if (extraRow && packLabel) {
        if (count > 1) {
          extraRow.hidden = false;
          packLabel.textContent = count + ' maillots' + (packState[3].active ? ' (1 OFFERT)' : '');
        } else {
          extraRow.hidden = true;
        }
      }

      // Totals — utilise prix RÉELS des produits sélectionnés
      let subtotal = variant.price;
      if (packState[2].active && packState[2].productPrice) {
        subtotal += packState[2].productPrice;
      }
      let discount = 0;
      if (packState[3].active && packState[3].productPrice) {
        subtotal += packState[3].productPrice;
        discount = packState[3].productPrice;
      }
      const total = subtotal - discount;

      const subEl = $('[data-sm-recap-subtotal]', tunnel);
      const savingsRow = $('[data-sm-recap-savings]', tunnel);
      const discEl = $('[data-sm-recap-discount]', tunnel);
      const totalEl = $('[data-sm-recap-total]', tunnel);
      const ctaPriceEl = $('[data-sm-cta-price]', tunnel);
      const installments3xEl = $('[data-sm-recap-3x]', tunnel);
      if (subEl) subEl.textContent = fmtMoney(subtotal);
      if (savingsRow) savingsRow.hidden = discount === 0;
      if (discEl) discEl.textContent = '− ' + fmtMoney(discount);
      if (totalEl) totalEl.textContent = fmtMoney(total);
      if (ctaPriceEl) ctaPriceEl.textContent = fmtMoney(total);
      if (installments3xEl) installments3xEl.textContent = fmtMoney(Math.round(total / 3));

      // Sync recap preview SVG (step 4)
      $$('[data-sm-jersey="preview-step4"] [data-sm-jersey-pseudo]', tunnel).forEach(t => {
        t.textContent = pseudo ? pseudo.toUpperCase() : ' ';
      });
      $$('[data-sm-jersey="preview-step4"] [data-sm-jersey-number]', tunnel).forEach(t => {
        t.textContent = num || ' ';
      });
      // Sync color on recap SVG
      if (colorBtn) {
        const hex = colorBtn.dataset.smHex;
        if (hex) {
          $$('[data-sm-jersey="preview-step4"]', tunnel).forEach(svg => {
            const main = $('[data-sm-stop="main"]', svg);
            const shadow = $('[data-sm-stop="shadow"]', svg);
            if (main) main.setAttribute('stop-color', hex);
            if (shadow) shadow.setAttribute('stop-color', darken(hex, 0.5));
          });
        }
      }
    }

    // ============================================================
    // FORM SUBMIT — Multi-add to cart
    // ============================================================
    if (form) {
      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        const variant = findMatchingVariant();
        if (!variant || !variant.available) {
          alert('Cette variante n\'est pas disponible.');
          return;
        }

        const submitBtn = $(SELECTORS.submitBtn, tunnel);
        const originalLabel = submitBtn ? submitBtn.innerHTML : '';
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.innerHTML = '<span>AJOUT EN COURS...</span>';
        }

        try {
          const hasPack = packState[2].active || packState[3].active;

          if (!hasPack) {
            // Single add — submit form natively
            const fd = new FormData(form);
            const res = await fetch('/cart/add.js', {
              method: 'POST',
              body: fd,
            });
            if (!res.ok) throw new Error('Add failed');
            window.location.href = '/cart';
            return;
          }

          // Multi-add
          const items = [];
          const totalItems = 1 + (packState[2].active ? 1 : 0) + (packState[3].active ? 1 : 0);

          // Slot 1
          const props1 = { '_pack': 'Maillot 1/' + totalItems };
          if (pseudoInput && pseudoInput.value.trim()) props1['Pseudo'] = pseudoInput.value.trim();
          if (numberInput && numberInput.value.trim()) props1['Numéro'] = numberInput.value.trim();
          if (textInput && textInput.value.trim()) props1['Texte libre'] = textInput.value.trim();
          items.push({ id: variant.id, quantity: 1, properties: props1 });

          // Slot 2
          if (packState[2].active) {
            const m2 = buildSlotItem(2, variant, totalItems);
            items.push(m2);
          }
          // Slot 3 — OFFERT
          if (packState[3].active) {
            const m3 = buildSlotItem(3, variant, totalItems);
            m3.properties['_offer'] = 'PACK_2_PLUS_1_FREE';
            items.push(m3);
          }

          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items }),
          });
          if (!res.ok) throw new Error('Multi-add failed');

          // Add cart note for discount tracking
          if (packState[3].active) {
            await fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                attributes: { 'pack_2_plus_1': 'true' },
                note: 'PACK 2+1 — le 3e maillot doit être offert',
              }),
            });
          }

          window.location.href = '/cart';
        } catch (err) {
          console.error('[SM] Add to cart error:', err);
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.innerHTML = '<span>ERREUR — RÉESSAYER</span>';
            setTimeout(() => { submitBtn.innerHTML = originalLabel; }, 2000);
          }
        }
      });
    }

    function buildSlotItem(slotNum, defaultVariant, totalItems) {
      const state = packState[slotNum];
      const pseudoSel = $(`[data-sm-slot-pseudo="${slotNum}"]`, tunnel);
      const numberSel = $(`[data-sm-slot-number="${slotNum}"]`, tunnel);
      const sizeSel = $(`[data-sm-slot-size="${slotNum}"]`, tunnel);

      // Variant ID : récupère via le state ou fallback sur defaultVariant
      let variantId = state.selectedVariantId;

      // Si selectedVariantId pas défini, prend la 1ère variant disponible du produit
      if (!variantId && state.productVariants && state.productVariants.length > 0) {
        const firstAvail = state.productVariants.find(v => v.available);
        variantId = firstAvail ? firstAvail.id : state.productVariants[0].id;
      }

      // Si on a une taille sélectionnée, retrouve la variant exacte
      if (sizeSel && sizeSel.value && state.productVariants) {
        const opt = sizeSel.options[sizeSel.selectedIndex];
        if (opt && opt.dataset.variantId) {
          variantId = opt.dataset.variantId;
        }
      }

      // Ultime fallback : variant principal du produit ouvert
      if (!variantId) variantId = defaultVariant.id;

      const props = { '_pack': `Maillot ${slotNum}/${totalItems}` };
      if (state.productTitle) props['_product'] = state.productTitle;
      if (pseudoSel && pseudoSel.value.trim()) props['Pseudo'] = pseudoSel.value.trim();
      if (numberSel && numberSel.value.trim()) props['Numéro'] = numberSel.value.trim();

      return { id: variantId, quantity: 1, properties: props };
    }

    // ============================================================
    // LIVE VIEWERS counter (subtle fluctuation) — both PDP and step 4
    // ============================================================
    const viewersEl = $('[data-sm-viewers]');
    if (viewersEl) {
      const base = parseInt(viewersEl.textContent, 10) || 12;
      let current = base;
      setInterval(() => {
        const delta = Math.random() > 0.5 ? 1 : -1;
        current = Math.max(base - 4, Math.min(base + 8, current + delta));
        viewersEl.textContent = current;
      }, 8000 + Math.random() * 4000);
    }
    // Step 4 viewers counter
    const viewersStep4 = $('[data-sm-viewers-count]', tunnel);
    if (viewersStep4) {
      let stepCurrent = 18 + Math.floor(Math.random() * 12); // 18-30
      viewersStep4.textContent = stepCurrent;
      setInterval(() => {
        const delta = Math.random() > 0.5 ? 1 : -1;
        stepCurrent = Math.max(15, Math.min(34, stepCurrent + delta));
        viewersStep4.textContent = stepCurrent;
      }, 6000 + Math.random() * 4000);
    }

    // ============================================================
    // COUNTDOWN URGENCY (step 4) — shipping cutoff at midnight
    // ============================================================
    const urgencyEl = $('[data-sm-urgency-time]', tunnel);
    if (urgencyEl) {
      const updateCountdown = () => {
        const now = new Date();
        const cutoff = new Date();
        cutoff.setHours(23, 59, 59, 0); // end of day
        let diff = cutoff - now;
        if (diff < 0) diff += 24 * 60 * 60 * 1000; // next day
        const hours = Math.floor(diff / (1000 * 60 * 60));
        const mins = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
        urgencyEl.textContent = `Commande dans les ${hours}h ${String(mins).padStart(2, '0')}min`;
      };
      updateCountdown();
      setInterval(updateCountdown, 60000); // update every minute
    }

    // ============================================================
    // PDP GALLERY THUMB SWITCH (bonus)
    // ============================================================
    const stageSlides = $$('.sm-stage-slide');
    $$('.sm-thumb').forEach(thumb => {
      thumb.addEventListener('click', () => {
        const idx = thumb.dataset.smThumb;
        $$('.sm-thumb').forEach(t => t.classList.remove('sm-active'));
        thumb.classList.add('sm-active');
        $$('.sm-stage-slide').forEach(s => s.classList.remove('sm-active'));
        const target = $(`.sm-stage-slide[data-sm-slide="${idx}"]`);
        if (target) target.classList.add('sm-active');
      });
    });

    // Init first variant
    updateVariant();
  }
})();